import { saveAs } from "file-saver";
import axios from "axios";

export const download = {
  methods: {
    async downloadPatientScan(id, fileName) {
      const resp = await axios.get(`/patientscans/${id}`, {
        responseType: "blob",
      });
      saveAs(resp.data, fileName.endsWith(".zip") ? fileName : fileName + ".zip");
    },
    async downloadTreatmentPlan(id, fileName) {
      const resp = await axios.get(
        `/treatmentplans/${id}`,
        {
          responseType: "blob",
        }
      );
      saveAs(resp.data, fileName.endsWith(".zip") ? fileName : fileName + ".zip");
    }
  }
}